import styled, { css } from 'styled-components'

import { Input } from '../common/Input'
import { DateInput } from '../common/DateInput'

import { createField } from './createField'

export const InputField = createField({ Component: Input })
export const DateField = createField({ Component: DateInput })

export const createWidth = (w) => css`
  margin-right: 33px;
  display: inline-block;
  max-width:${w}px;
  width: ${w}px;
`

const SmallWidth = createWidth(104)
export const MaxWidth = createWidth(289)

export const InputFieldWidth = styled(InputField)`
  ${MaxWidth}
`

export const DateFieldWidth = styled(DateField)`
  ${MaxWidth}
`

export const SmallDateField = styled(DateField)`
  ${SmallWidth}
`
